//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name:'book',
	props:{
		product:{
			type:Array,
			default(){
				return []
			}
		},
		transportType:{
			type:String,
			default:''
		}
	}
}
